import React, { createContext, useReducer, useContext } from "react";

export enum VISIBLE_COMPONENTS_ACTIONS{
    ADD_VISIBLE_COMPONENT = 'add_visible_component',
    REMOVE_VISIBLE_COMPONENT = 'remove_visible_component'
}

export enum VISIBLE_COMPONENTS_NAMES{
    HERO = 'hero',
    FOOTER = 'footer'
}

const visibleComponentsReducer = (state:Array<String>, action) => {
    switch (action.type) {
        case VISIBLE_COMPONENTS_ACTIONS.ADD_VISIBLE_COMPONENT: 
            return [
                ...state,
                action.component
            ];
        case VISIBLE_COMPONENTS_ACTIONS.REMOVE_VISIBLE_COMPONENT:
            const index = state.indexOf(action.component);
            const newState = [...state]
            if (index > -1) {
                newState.splice(index, 1)
            }
            return newState;
        default: return state;
    }
};

const VisibleComponentsContext = createContext(null);

export const useVisibleComponentsContext = () => useContext(VisibleComponentsContext);

export const VisibleComponentsProvider = ({ children }) => {
    const [visibleComponents, dispatch] = useReducer(visibleComponentsReducer, []);

    return (
        <VisibleComponentsContext.Provider value={{visibleComponents, dispatch}}>
            { children }
        </VisibleComponentsContext.Provider>
    );
}

export default VisibleComponentsContext;